import { DateFormat } from '@cp/src/utils/DateHelper';
import dayjs from 'dayjs';
import { AnswerType, IAnswerView } from '../interfaces';
import { getNumberFormat } from '@cp/src/utils/commonUtils';

export const sanitizeString = (str = '') => {
  return str?.trim() || '--';
};

export const getQuestionText = (answerItem: IAnswerView) => {
  return (answerItem?.questionKey ? answerItem?.questionName : answerItem?.questionText) || '--';
};

export const getAnswerText = (answer: IAnswerView) => {
  switch (answer?.answerType) {
    case AnswerType.OPTIONS:
      return sanitizeString(answer.optionText);
    case AnswerType.TEXT:
    case AnswerType.TIME:
      return sanitizeString(answer.inputText);
    case AnswerType.DATE:
      return sanitizeString(
        dayjs(answer?.inputDate as string).format(DateFormat.LONG_DATE_FORMAT_WITHOUT_TIME)
      );
    case AnswerType.AMOUNT:
      return getNumberFormat(answer?.inputAmount, 0);
    case AnswerType.PHONE_NUMBER:
      return sanitizeString(answer.inputText);
    default:
      return sanitizeString();
  }
};
